import { setContext } from 'apollo-link-context';

export const gatewayConnector = (store, getterTokenName) => {
    return {
        authMiddleware: setContext(async () => {
            if (!store.getters[getterTokenName]) return {};

            return {
                headers: {
                    authorization: store.getters[getterTokenName] || null,
                    'project-id': store.getters['businessUnit/project_id'] || null
                },
            };
        }),
    };
};

export const authTokenWS = (store, getterTokenName) => {
    return function () {
        return {
            Authorization: store.getters[getterTokenName] || null,
        };
    };
};
